import { VALTYPES, VALTYPE_ANY } from '../../../../data/interfaces';
import { createColorMappingAspect, createColorMappingConfigs } from '../../helpers/colorMappingInfo';
import { CONFIGPARAMTYPES, createConfigParamTypeRange } from '../../helpers/configParams';
import { TpChartManifest } from '../interfaces';
import { LongitNumerical } from './LongitNumerical';

export const manifestLongitNumerical: TpChartManifest = {
  id: 'LongitNumerical',
  name: 'Longitudinal numerical plot',
  description: `
Visualizes longitudinal data as a "spaghetti plot": a set of lines connecting the different measurements for each entity in the plot.

The primary table contains the entities to be visualised (and for which longitudinal data is present). A secondary table contains
the individual readouts.
`,
  component: LongitNumerical,
  canvasBased: true,
  groups: [
    { groupId: 'lines', groupName: 'Lines' },
    { groupId: 'points', groupName: 'Points' },
  ],
  aspects: [
    createColorMappingAspect('color', 'Line color data', 'lines', 0.5, 'lines'),
    {
      id: 'hoverLabel',
      name: 'Hover label',
      description: 'Text to be displayed when the mouse hovers over a line.',
      groupId: 'lines',
      required: false,
      dataType: VALTYPE_ANY,
    },
  ],
  secondTable: {
    aspects: [
      {
        id: 'linkField',
        name: 'Link field',
        description:
          'Property used to map measurements to entities in the primary table. It should contain the primary key of the entity the measurement corresponds to.',
        groupId: 'points',
        required: true,
        dataType: [VALTYPES.CATEGORICAL],
        hidden: true,
      },
      {
        id: 'sort',
        name: 'Ordering',
        groupId: 'points',
        description: 'Property that defines the order of drawing and connecting the measurements or a single entity.',
        required: true,
        quality: 1,
        dataType: [VALTYPES.NUMBER, VALTYPES.INTEGER],
      },
      {
        id: 'x',
        name: 'X axis',
        description: 'X coordinate of a single measurement',
        groupId: 'points',
        required: true,
        quality: 1,
        dataType: [VALTYPES.NUMBER, VALTYPES.INTEGER],
      },
      {
        id: 'y',
        name: 'Y axis',
        description: 'Y coordinate of a single measurement',
        groupId: 'points',
        required: true,
        quality: 0.95,
        dataType: [VALTYPES.NUMBER, VALTYPES.INTEGER],
      },
    ],
  },
  configParams: [
    ...createColorMappingConfigs('color', 'Color', 'lines'),
    {
      id: 'pointSizeFactor',
      name: 'Point size',
      description: 'Scaling factor for the overall size of the points in the plot.',
      groupId: 'points',
      paramType: createConfigParamTypeRange(0.2, 4, 0.1, 1),
    },
    {
      id: 'opacity',
      name: 'Opacity',
      description: `
In case a plot contains many overlapping lines and points, lowering the opacity (i.e. increasing transparency)
can help reveal the data structure.`,
      groupId: 'lines',
      paramType: createConfigParamTypeRange(0.1, 1, 0.1, 0.7),
    },
    {
      id: 'customXAxis',
      name: 'Custom x axis',
      groupId: 'lines',
      description: `
Optionally specific a custom legend for the X axis, by providing a set of X coordinate values and corresponding labels. Example content:
\`\`\`
labels:
- value: [X coordinate 1]
  text: Label 1
- value: [X coordinate 2]
  text: Label 2
\`\`\`
 `,
      hidden: true,
      paramType: { configParamTypeId: CONFIGPARAMTYPES.JSON },
    },
  ],
  examples: [
    {
      id: 'longitnumerical_1',
    },
  ],
};
